import React from "react";
import Joi from "joi-browser";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Pagination, Form, Modal, Button, Spinner } from "react-bootstrap";
import { RiRepeatLine } from "react-icons/ri";
import { RiDeleteBin2Line } from "react-icons/ri";
import { getLeads, getUsersCount, deleteUser, addUser, convertLead } from "../services/userService";
import PageLoading from "./common/pageLoading";
import FormComponent from "./common/formComponent";
import FloatingAddButton from "./common/floatingAddButton";

class Leads extends FormComponent {
  state = {
    data: {
      fullName: "",
      email: "",
      phone: "",
      category: "Lead",
      permission: "None",
      address: "",
      notes: undefined,
    },
    loading: "",
    processing: false,
    errors: {},
    searchQuery: "",
    leads: [],
    selectedLead: {},
    pageSize: 20,
    currentPage: 1,
    totalLeads: 0,
    showAddModal: false,
    showConfirmModal: false,
    showConvertmModal: false
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  schema = {
    fullName: Joi.string().required().label("Full Name"),
    email: Joi.string().email().required().label("Email"),
    phone: Joi.string().required().label("Phone Number"),
    category: Joi.string().required().label("Category"),
    permission: Joi.string().required().label("Permission"),
    address: Joi.string().required().label("Address"),
    notes: Joi.string().max(50).optional().label("Notes"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload, leads: originalLeads } = this.state;

    try {
      const { data: newLead } = await addUser(payload);

      const leads = [...originalLeads];
      leads.unshift(newLead);
      this.setState({ leads, showAddModal: false });
      toast.success("Lead Added");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  handleSearch = async (e) => {
    this.setState({ loading: true });
    const { currentPage, pageSize } = this.state;
    const value = e.currentTarget.value;
    this.setState({ searchQuery: value, currentPage: 1 });
    await this.populateLeads(currentPage, pageSize, value);
  };

  handleDeleteLead = async (leadId) => {
    this.setState({ processing: true });
    const { leads: originalLeads } = this.state;

    const leads = originalLeads.filter((l) => l._id !== leadId);
    this.setState({ leads, showConfirmModal: false });

    try {
      await deleteUser(leadId);
      toast.success("Lead Deleted");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
        this.setState({ leads: originalLeads });
      }
    }
    this.setState({ processing: false });
  };

  handleConvertLead = async (leadId) => {
    this.setState({ processing: true });
    const { leads: originalLeads, data } = this.state;

    const leads = originalLeads.filter((l) => l._id !== leadId);
    this.setState({ leads, showConvertModal: false });

    try {
      await convertLead(leadId, data);
      toast.success("Lead Converted Successfully");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
        this.setState({ leads: originalLeads });
      }
    }
    this.setState({ processing: false });
  };

  showConfirmModal = (selectedLead) => {
    this.setState({ showConfirmModal: true, selectedLead });
  };

  showConvertModal = (selectedLead) => {
    console.log(selectedLead)
    const data = { ...this.state.data };
    data.fullName = selectedLead.fullName;
    data.email = selectedLead.email;
    data.phone= selectedLead.phone;
    data.permission= selectedLead.permission;
    data.address= selectedLead.address;
    data.notes = selectedLead.notes;
    console.log(data)
    this.setState({ data, showConvertModal: true, selectedLead });
  };

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleClose = () => {
    this.setState({ showAddModal: false, showConfirmModal: false, showConvertModal: false });
  };

  async componentDidMount() {
    const { currentPage, pageSize, searchQuery } = this.state;
    await this.populateLeads(currentPage, pageSize, searchQuery);
  }

  async populateLeads(currentPage, pageSize, searchQuery) {
    try {
      const { data: leads } = await getLeads(currentPage, pageSize, searchQuery); //limited result
      const { data: totalLeads } = await getUsersCount("Lead", searchQuery);
      this.setState({ leads, totalLeads });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  handlePageChange = async (direction) => {
    this.setState({ loading: true });
    const { currentPage, pageSize, searchQuery } = this.state;
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    await this.populateLeads(newPage, pageSize, searchQuery);
    this.setState({ currentPage: newPage });
  };

  render() {
    const {
      data,
      errors,
      leads,
      selectedLead,
      pageSize,
      currentPage,
      totalLeads,
      searchQuery,
      showAddModal,
      showConfirmModal,
      showConvertModal,
      loading,
      processing,
    } = this.state;

    const pagesCount = Math.ceil(totalLeads / pageSize);

    return (
      <React.Fragment>
        <Form>
          <Form.Group controlId="searchQuery">
            <Form.Control
              type="text"
              name="searchQuery"
              value={searchQuery}
              autoFocus
              autoComplete="off"
              onChange={this.handleSearch}
              placeholder="Search Leads By Name, Email or Phone Number..."
            />
          </Form.Group>
        </Form>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div>
                <h5>Leads</h5>
              </div>
            </div>
            <div className="card-body">
              <span className="card-text">
                {loading && <PageLoading loading={loading} />}
                {!loading && leads.length === 0 && <span>No Leads to Display</span>}
                {!loading && <FloatingAddButton classes="float-right mt-2 mb-3" onClick={this.handleShowAddModal} />}
                {!loading && leads.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Full Name</StyledTableCell>
                          <StyledTableCell>Email</StyledTableCell>
                          <StyledTableCell>Phone Number</StyledTableCell>
                          <StyledTableCell>Notes</StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {leads.map((lead) => (
                          <StyledTableRow key={lead._id}>
                            <StyledTableCell>
                              <Link to={`/leads/${lead._id}`}>{lead.fullName}</Link>
                            </StyledTableCell>
                            <StyledTableCell>{lead.email}</StyledTableCell>
                            <StyledTableCell>{lead.phone}</StyledTableCell>
                            <StyledTableCell>{lead.notes}</StyledTableCell>
                            <StyledTableCell>
                            <Button className="mr-2"
                                onClick={() =>
                                  this.showConvertModal(lead)
                                }
                                variant="success"
                              >
                                <RiRepeatLine />
                              </Button>
                              <Button
                                onClick={() =>
                                  this.showConfirmModal({
                                    _id: lead._id,
                                    fullName: lead.fullName,
                                  })
                                }
                                variant="danger"
                              >
                                <RiDeleteBin2Line />
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {!loading && pagesCount > 0 && (
                  <Pagination className="mt-5">
                    {pagesCount > 1 && (
                      <React.Fragment>
                        {currentPage !== 1 && (
                          <Pagination.Item onClick={() => this.handlePageChange("prev")}>Previous</Pagination.Item>
                        )}
                        <Pagination.Item>
                          Page {currentPage} of {pagesCount}
                        </Pagination.Item>
                        {currentPage !== pagesCount && (
                          <Pagination.Item onClick={() => this.handlePageChange("next")}>Next</Pagination.Item>
                        )}
                      </React.Fragment>
                    )}
                  </Pagination>
                )}
              </span>
            </div>
          </div>
        </Paper>

        <Modal show={showAddModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Lead</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <Form.Group controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  name="fullName"
                  onChange={this.handleChange}
                  value={data.fullName}
                  size="sm"
                  type="text"
                  autoFocus
                />
                {errors.fullName && <span className="text-danger">{errors.fullName}</span>}
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control name="email" onChange={this.handleChange} value={data.email} size="sm" type="email" />
                {errors.email && <span className="text-danger">{errors.email}</span>}
              </Form.Group>

              <Form.Group controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control name="phone" onChange={this.handleChange} value={data.phone} size="sm" type="tel" />
                {errors.phone && <span className="text-danger">{errors.phone}</span>}
              </Form.Group>

              <Form.Group controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="3"
                  name="address"
                  onChange={this.handleChange}
                  value={data.address}
                  size="sm"
                  type="address"
                />
                {errors.address && <span className="text-danger">{errors.address}</span>}
              </Form.Group>

              <Form.Group controlId="notes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="3"
                  name="notes"
                  onChange={this.handleChange}
                  value={data.notes}
                  size="sm"
                  type="address"
                />
                {errors.notes && <span className="text-danger">{errors.notes}</span>}
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal show={showConfirmModal} size="md" centered onHide={this.handleClose}>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title>Delete Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the lead: {selectedLead.fullName}?
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              No
            </Button>
            <Button
              disabled={processing}
              onClick={() => this.handleDeleteLead(selectedLead._id)}
              type="submit"
              variant="primary"
            >
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showConvertModal} size="md" centered onHide={this.handleClose}>
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>Convert Lead</Modal.Title>
          </Modal.Header>
          <Form>
          <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="tarcategoryiff">
                  <Form.Label>Category</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="category"
                    onChange={this.handleChange}
                    value={data.category}
                    size="sm"
                  >
                    <option value="">Select Category</option>
                    <option>Individual</option>
                  <option>Business</option>
                  </Form.Control>
                  {errors.category && <span className="text-danger">{errors.category}</span>}
                </Form.Group>
              </React.Fragment>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              Cancel
            </Button>
            <Button
              disabled={processing}
              onClick={() => this.handleConvertLead(selectedLead._id)}
              type="submit"
              variant="primary"
            >
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Convert
            </Button>
          </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Leads;
